import moment from "moment";
import { FunctionField, ReferenceField } from "react-admin";
interface ISubcontractorHolidayPaymentTermPeriodField {
  routeType: string;
  columnType?: string;
}
const SubcontractorHolidayPaymentTermPeriodField = ({
  routeType,
}: ISubcontractorHolidayPaymentTermPeriodField) => {
  switch (routeType) {
    case "Regular":
      return (
        <ReferenceField
          reference="academicTerms"
          source="regularRouteJoinPeriodTermId"
          linkType={false}
        >
          <FunctionField
            render={(record: any) =>
              `${record.name} (${moment
                .utc(record.startDate)
                .format("DD MMM YYYY")} - ${moment
                .utc(record.endDate)
                .format("DD MMM YYYY")})`
            }
          />
        </ReferenceField>
      );
    case "CCA":
      return (
        <ReferenceField
          reference="ccaAcademicTerms"
          source="ccaRouteJoinPeriodTermId"
          linkType={false}
        >
          <FunctionField
            render={(record: any) =>
              `${record.name} (${moment
                .utc(record.startDate)
                .format("DD MMM YYYY")} - ${moment
                .utc(record.endDate)
                .format("DD MMM YYYY")})`
            }
          />
        </ReferenceField>
      );
    default:
      return <></>;
  }
};
export default SubcontractorHolidayPaymentTermPeriodField;
